<template>
  <div class="billboardChannel">
    <div class="billboardChannel__header">
      <div class="billboardChannel__header__left">
        <h1 class="medium-title">Billboard</h1>
        <div class="billboardChannel__header__left__menubar">
          <router-link class="regular-font" tag="li" :to="{name: 'billboardlocation'}">Location</router-link>
          <router-link class="regular-font" tag="li" :to="{name: 'billboardplacement'}">Placement</router-link>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "adx-channel-billboard",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {}
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>